
import React, { useMemo } from 'react';
import { SparcInteraction } from '@/services/agentic/sparcSessionService';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { List } from 'lucide-react';

interface TimelineFilterProps {
  interactions: SparcInteraction[];
  onFilterChange: (filter: string | null) => void;
  currentFilter: string | null;
}

const TimelineFilter: React.FC<TimelineFilterProps> = ({
  interactions,
  onFilterChange,
  currentFilter
}) => {
  // Extract unique task types for filtering
  const taskOptions = useMemo(() => {
    const uniqueTasks = new Map<string, { id: string, name: string }>();
    
    interactions.forEach(interaction => {
      if (interaction.task_id && interaction.task_name) {
        uniqueTasks.set(interaction.task_id, {
          id: interaction.task_id,
          name: interaction.task_name
        });
      }
    });
    
    return Array.from(uniqueTasks.values());
  }, [interactions]);
  
  if (taskOptions.length === 0) {
    return null;
  }
  
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center">
        <List className="h-4 w-4 mr-2 text-muted-foreground" />
        <span className="text-sm font-medium">Filter by task:</span>
      </div>
      
      <div className="flex items-center gap-2">
        {currentFilter && (
          <Badge 
            variant="outline" 
            className="cursor-pointer"
            onClick={() => onFilterChange(null)}
          >
            Clear filter × 
          </Badge>
        )}
        
        <Select 
          value={currentFilter || ''} 
          onValueChange={(value) => onFilterChange(value || null)}
        >
          <SelectTrigger className="w-[220px]">
            <SelectValue placeholder="Select a task type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="">All tasks</SelectItem>
            {taskOptions.map(task => (
              <SelectItem key={task.id} value={task.id}>
                {task.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default TimelineFilter;
